/**
 * Centre d’aide (/help) — volumineux, séparé de i18n-ar.ts.
 */
export const arHelpTranslations: Record<string, string> = {
  'pages.help.title': 'مركز المساعدة',
  'pages.help.description': 'التوثيق والدعم',
  'pages.help.hubIntro':
    'مواضيع تغطي استخدام Lyrra: ستتمكنون قريبًا من ربط كل ورقة بتوثيقكم، دروسكم التعليمية أو تذاكر الدعم.',
  'pages.help.searchPlaceholder': 'بحث في الموضوع…',
  'pages.help.noResults': 'لا نتائج لهذا البحث.',
  'pages.help.configHint':
    'محتوى تجريبي: اربطوا عناوين URL أو مقالات أو قاعدة معرفة عندما تكونون جاهزين.',
  'pages.help.comingSoonDesc':
    'الوصول إلى التوثيق والدروس التعليمية والدعم الفني لاستخدام المنصة.',
  'pages.help.modal.steps': 'عمليًا',
  'pages.help.modal.tips': 'نصائح',
  'pages.help.modal.related': 'انظر أيضًا',
  'pages.help.openArticle': 'فتح الورقة',
  'pages.help.onboardingFlowMissing': 'التدريب غير موجود',
  'pages.help.onboardingFlowMissingDesc':
    'شغّلوا أوامر seed في الواجهة الخلفية (مثل db:seed:onboarding-eduflow وdb:seed:onboarding-navigation-eduflow وغيرها من db:seed:onboarding-*-eduflow) أو عيّنوا المتغيّرات بيئة VITE_ONBOARDING_*_FLOW_ID.',
  'pages.help.onboardingDashboardPlayerTitle': 'تدريب — لوحة تحكم Lyrra (تهيئة)',
  'pages.help.onboardingNavigationPlayerTitle': 'تدريب — التنقل والقائمة الجانبية Lyrra (تهيئة)',
  'pages.help.onboardingProfilePlayerTitle': 'تدريب — الملف الشخصي وتفضيلات Lyrra (تهيئة)',
  'pages.help.onboardingRolesPlayerTitle': 'تدريب — الأدوار وصلاحيات الوصول Lyrra (تهيئة)',
  'pages.help.onboardingBlockTypesPlayerTitle': 'تدريب — أنواع كتل EduFlow (تهيئة)',
  'pages.help.onboardingDesignerOverviewPlayerTitle': 'تدريب — نظرة عامة على مُصمّم EduFlow (تهيئة)',
  'pages.help.onboardingBranchesPlayerTitle': 'تدريب — التفرعات والشروط EduFlow (تهيئة)',
  'pages.help.onboardingValidationPlayerTitle': 'تدريب — التحقق من المسار EduFlow (تهيئة)',
  'pages.help.onboardingObjectivesPlayerTitle': 'تدريب — الأهداف التربوية EduFlow (تهيئة)',
  'pages.help.onboardingAiDesignerPlayerTitle': 'تدريب — مساعد الذكاء الاصطناعي في مصمّم LyrraOne (تهيئة)',
  'pages.help.onboardingPublicationStatusPlayerTitle': 'تدريب — المسودة والنشر والتحديثات LyrraOne (تهيئة)',
  'pages.help.onboardingPublicationLinksPlayerTitle': 'تدريب — روابط الوصول والمشاركة LyrraOne (تهيئة)',
  'pages.help.onboardingCatalogVisibilityPlayerTitle': 'تدريب — الكتالوج والظهور LyrraOne (تهيئة)',
  'pages.help.onboardingEnrollmentsPlayerTitle': 'تدريب — التسجيلات والمشاركون LyrraOne (تهيئة)',
  'pages.help.onboardingGroupsCohortsPlayerTitle': 'تدريب — المجموعات والأفواج LyrraOne (تهيئة)',
  'pages.help.onboardingProgressPlayerTitle': 'تدريب — التقدّم والوقت المستغرق LyrraOne (تهيئة)',
  'pages.help.onboardingCertificatesPlayerTitle': 'تدريب — الشهادات الممنوحة LyrraOne (تهيئة)',
  'pages.help.onboardingMediaLibraryPlayerTitle': 'تدريب — مكتبة الوسائط LyrraOne (تهيئة)',

  'help.categories.analytics.description':
    'لوحات معلومات، مرشحات وتصدير لمتابعة أثر التدريبات.',
  'help.categories.analytics.title': 'التحليلات والتقارير',
  'help.categories.apprenants.description':
    'متابعة التسجيلات والأفواج وتقدّم المشاركين.',
  'help.categories.apprenants.title': 'المتعلّمون، المجموعات والمتابعة',
  'help.categories.boutique.description':
    'بيع أو منح التدريبات عند تفعيل المتجر.',
  'help.categories.boutique.title': 'المتجر وتحقيق الدخل',
  'help.categories.demarrage.description':
    'إتقان الواجهة، ملفكم الشخصي والتنقل اليومي في Lyrra.',
  'help.categories.demarrage.title': 'البدء والحساب',
  'help.categories.donnees.description':
    'اللائحة العامة لحماية البيانات، الأرشفة، حقوق الأشخاص وممارسات الأمان.',
  'help.categories.donnees.title': 'البيانات الشخصية والأمان',
  'help.categories.eduflow.description':
    'تصميم مسارات تعليمية بكتل، وصلات ومنطق التنقل.',
  'help.categories.eduflow.title': 'المسارات ومصمّم EduFlow',
  'help.categories.evaluation.description':
    'اختبارات، تقييمات، استبيانات وآراء لقياس المكتسبات.',
  'help.categories.evaluation.title': 'التقييم والتعليم النشط',
  'help.categories.institution.description':
    'ضبط هيكل مؤسستكم، المتعاونين وتنظيم المحتويات.',
  'help.categories.institution.title': 'المؤسسة والفريق',
  'help.categories.marque.description':
    'مواءمة الألوان، التسميات ومسار المتعلّم مع هويتكم.',
  'help.categories.marque.title': 'العلامة وتجربة المستخدم',
  'help.categories.medias.description':
    'إدارة المكتبة، الاستيراد وأدوات الصوت/الفيديو/الصورة المدمجة في Lyrra.',
  'help.categories.medias.title': 'الوسائط والاستوديو الإبداعي',
  'help.categories.parcours-v2.description':
    'حملات، كفاءات، تكاملات: كل ما يغني إدارة التدريب.',
  'help.categories.parcours-v2.title': 'وظائف متقدمة والخارطة',
  'help.categories.podcasts.description':
    'إنشاء وبث محتوى صوتي طويل خارج المسار كتلة بكتلة.',
  'help.categories.podcasts.title': 'البودكاست والكتب الصوتية',
  'help.categories.publication.description':
    'إتاحة مسار للمتعلّمين ومشاركة نقاط الوصول المناسبة.',
  'help.categories.publication.title': 'النشر والنشر الخارجي',
  'help.categories.qualite.description':
    'إطارات الجودة الفرنسية: تتبع، أهداف وأدلة للتدقيق.',
  'help.categories.qualite.title': 'الجودة وQualiopi والامتثال التربوي',
  'help.categories.support.description':
    'عند عطل تقني أو وظيفي، أين تبحثون ومن تتصلون به.',
  'help.categories.support.title': 'استكشاف الأخطاء والدعم',

  'help.configHint':
    'محتوى تحريري: اربطوا عناوين URL أو مقالات أو قاعدة معرفة عندما تكونون جاهزين.',
  'help.description': 'التوثيق والدعم',
  'help.hubIntro':
    'مواضيع تغطي استخدام Lyrra: ستتمكنون قريبًا من ربط كل ورقة بتوثيقكم، دروسكم أو تذاكر الدعم.',
  'help.modal.expectedAnswer': 'الإجابة المتوقعة:',
  'help.modal.fallbackHighlight1': 'ورقة',
  'help.modal.fallbackHighlight2': 'منصة تدريب',
  'help.modal.fallbackHighlight3': 'يُكمَل',
  'help.modal.fallbackSectionHeading': 'ما يجب تذكّره',
  'help.modal.fallbackSectionParagraph':
    'سيُغنى محتوى هذه الورقة أو يُربط بتوثيقكم الداخلي.',
  'help.modal.fallbackStep1Desc':
    'استخدموا القائمة الجانبية أو لوحة التحكم للوصول إلى الوحدة المعنية.',
  'help.modal.fallbackStep1Title': 'فتح الوظيفة',
  'help.modal.fallbackStep2Desc':
    'الشاشات ترشدكم: احفظوا كثيرًا وجرّبوا المعاينة عند توفرها.',
  'help.modal.fallbackStep2Title': 'اتباع المسار المهني',
  'help.modal.fallbackStep3Desc':
    'دوّنوا خصوصيات مؤسستكم (عمليات الموارد البشرية، التسمية، الشارة) لفريقكم.',
  'help.modal.fallbackStep3Title': 'التو документات الداخلية',
  'help.modal.fallbackTip':
    'عند الشك، تحققوا من دوركم (مُدرّب، مسؤول، موارد بشرية): القوائم تعتمد على ذلك.',
  'help.modal.quiz': 'اختبار تحقق',
  'help.modal.related': 'انظر أيضًا',
  'help.modal.resources': 'موارد',
  'help.modal.steps': 'عمليًا',
  'help.modal.tips': 'نصائح',
  'help.noResults': 'لا نتائج لهذا البحث.',

  'help.onboarding.ai-designer': 'تدريب — مساعد الذكاء الاصطناعي في مصمّم LyrraOne (تهيئة)',
  'help.onboarding.blocks': 'تدريب — أنواع كتل EduFlow (تهيئة)',
  'help.onboarding.branches': 'تدريب — التفرعات والشروط EduFlow (تهيئة)',
  'help.onboarding.catalog-visibility': 'تدريب — الكتالوج والظهور LyrraOne (تهيئة)',
  'help.onboarding.certificates': 'تدريب — الشهادات الممنوحة LyrraOne (تهيئة)',
  'help.onboarding.dashboard': 'تدريب — لوحة تحكم Lyrra (تهيئة)',
  'help.onboarding.designer-overview': 'تدريب — نظرة عامة على مصمّم EduFlow (تهيئة)',
  'help.onboarding.enrollments': 'تدريب — التسجيلات والمشاركون LyrraOne (تهيئة)',
  'help.onboarding.groups-cohorts': 'تدريب — المجموعات والأفواج LyrraOne (تهيئة)',
  'help.onboarding.media-library': 'تدريب — مكتبة الوسائط LyrraOne (تهيئة)',
  'help.onboarding.navigation': 'تدريب — التنقل والقائمة الجانبية Lyrra (تهيئة)',
  'help.onboarding.objectives': 'تدريب — الأهداف التربوية EduFlow (تهيئة)',
  'help.onboarding.profile': 'تدريب — الملف الشخصي وتفضيلات Lyrra (تهيئة)',
  'help.onboarding.progress': 'تدريب — التقدّم والوقت المستغرق LyrraOne (تهيئة)',
  'help.onboarding.publication-links': 'تدريب — روابط الوصول والمشاركة LyrraOne (تهيئة)',
  'help.onboarding.publication-status': 'تدريب — المسودة والنشر والتحديثات LyrraOne (تهيئة)',
  'help.onboarding.roles': 'تدريب — الأدوار وصلاحيات الوصول Lyrra (تهيئة)',
  'help.onboarding.validation': 'تدريب — التحقق من المسار EduFlow (تهيئة)',

  'help.onboardingFlowMissing': 'التدريب غير موجود',
  'help.onboardingFlowMissingDesc':
    'شغّلوا أوامر db:seed:onboarding-eduflow وdb:seed:onboarding-navigation-eduflow في الواجهة الخلفية، أو عيّنوا المتغيّرات VITE_ONBOARDING_*_FLOW_ID.',

  'help.openArticle': 'فتح الورقة',
  'help.searchPlaceholder': 'بحث في الموضوع…',
  'help.title': 'مركز المساعدة',

  'help.topics.analytics-exports.description':
    'تجهيز الاستخراجات للتقرير الداخلي أو التنظيمي.',
  'help.topics.analytics-exports.title': 'التصدير وتقارير الموارد البشرية',
  'help.topics.analytics-indicateurs.description':
    'معدلات الإكمال، التفاعل، التوزيع حسب الحالة والوقت على الكتل.',
  'help.topics.analytics-indicateurs.title': 'مؤشرات رئيسية',
  'help.topics.analytics-vue.description':
    'تخصيص الرسوم البيانية، الفترات والمرشح حسب التدريب لتحليل البيانات.',
  'help.topics.analytics-vue.title': 'نظرة تحليلية شاملة',
  'help.topics.app-certificats.description':
    'التحقق من الشهادات المُنشأة وشروط النجاح المرتبطة.',
  'help.topics.app-certificats.title': 'الشهادات الممنوحة',
  'help.topics.app-groupes.description':
    'استخدام المجموعات لتقسيم الجمهور وتسهيل الحملات أو التقارير.',
  'help.topics.app-groupes.title': 'المجموعات والأفواج',
  'help.topics.app-inscriptions.description':
    'الاطلاع على قائمة المتعلّمين في مسار، حالاتهم وسجل الوصول.',
  'help.topics.app-inscriptions.title': 'التسجيلات والمشاركون',
  'help.topics.app-progression.description':
    'تفسير التقدّم، الإكمالات ووقت التفاعل في الكتل.',
  'help.topics.app-progression.title': 'التقدّم والوقت المستغرق',
  'help.topics.boutique-offres.description':
    'ربط المسارات بمنتجات أو رموز وصول حسب نموذجكم الاقتصادي.',
  'help.topics.boutique-offres.title': 'العروض والتسعير',
  'help.topics.boutique-paiement.description':
    'فهم مسار الشراء لدى المتعلّم والتأكيدات لدى المؤسسة.',
  'help.topics.boutique-paiement.title': 'المدفوعات والفوترة',
  'help.topics.demarrage-navigation.description':
    'العثور على مساحات المشاريع، التدريبات، الوسائط، التحليلات والإعدادات حسب دوركم.',
  'help.topics.demarrage-navigation.title': 'التنقل والقائمة الجانبية',
  'help.topics.demarrage-profil.description':
    'تحديث معلوماتكم، لغة الواجهة والإشعارات.',
  'help.topics.demarrage-profil.title': 'الملف الشخصي والتفضيلات',
  'help.topics.demarrage-roles.description':
    'فهم الفوارق بين المُدرّب، مسؤول المؤسسة، الموارد البشرية والمتعلّم.',
  'help.topics.demarrage-roles.title': 'الأدوار وصلاحيات الوصول',
  'help.topics.demarrage-tableau-bord.description':
    'قراءة المؤشرات الرئيسية، الوصول السريع إلى المسارات الأخيرة والاختصارات.',
  'help.topics.demarrage-tableau-bord.title': 'لوحة تحكم التدريب',
  'help.topics.donnees-conservation.description':
    'مبادئ مدة أرشفة التقدّمات وأدلة التدريب.',
  'help.topics.donnees-conservation.title': 'مدة الحفظ',
  'help.topics.donnees-mots-de-passe.description':
    'ممارسات جيدة لكلمات المرور، الجلسات وتفويض الوصول.',
  'help.topics.donnees-mots-de-passe.title': 'الحسابات والمصادقة',
  'help.topics.donnees-rgpd.description':
    'الغايات من البيانات المجمّعة في Lyrra ومسؤولية مسؤول التدريب.',
  'help.topics.donnees-rgpd.title': 'اللائحة العامة وسجل المعالجات',
  'help.topics.eduflow-blocs.description':
    'اختيار وضبط الكتل المناسبة: نص، فيديو، صوت، تقييم، تفرع، إلخ.',
  'help.topics.eduflow-blocs.title': 'أنواع الكتل (محتوى، اختبار، وسائط…)',
  'help.topics.eduflow-branches.description':
    'إدارة عدة مخارج، التقاء المسارات وقواعد التنقل.',
  'help.topics.eduflow-branches.title': 'التفرعات والشروط',
  'help.topics.eduflow-concept.description':
    'لوحة العمل، لوحة الكتل، التحديد، التكبير والتنظيم البصري للمسار.',
  'help.topics.eduflow-concept.title': 'نظرة عامة على المصمّم',
  'help.topics.eduflow-ia.description':
    'اقتراح أو تعديل الكتل بمساعدة المساعد، مع مراجعة بشرية دائمة.',
  'help.topics.eduflow-ia.title': 'مساعد الذكاء الاصطناعي في المصمّم',
  'help.topics.eduflow-objectifs.description':
    'ربط الأهداف بالكتل لهيكلة مرجع تدريبكم.',
  'help.topics.eduflow-objectifs.title': 'الأهداف التربوية',
  'help.topics.eduflow-validation.description':
    'استخدام لوحة التحقق لاكتشاف الأخطاء والتحذيرات قبل النشر.',
  'help.topics.eduflow-validation.title': 'التحقق من المسار',
  'help.topics.eval-auto-eval.description':
    'اقتراح مسارات تكيفية حسب النتائج.',
  'help.topics.eval-auto-eval.title': 'التقييم الذاتي والعلاج التعويضي',
  'help.topics.eval-ouverte.description':
    'تنظيم جمع الإجابات الحرة والتصحيح اليدوي أو شبه الآلي.',
  'help.topics.eval-ouverte.title': 'أسئلة مفتوحة والتصحيح',
  'help.topics.eval-quiz.description':
    'ضبط المعايير، التغذية الراجعة والمحاولات لاختيار من متعدد فعّال.',
  'help.topics.eval-quiz.title': 'اختبارات وأسئلة اختيار',
  'help.topics.inst-collaborateurs.description':
    'إضافة مُدرّبين أو مسؤولين أو موارد بشرية وإدارة الأذونات.',
  'help.topics.inst-collaborateurs.title': 'المستخدمون والدعوات',
  'help.topics.inst-structure.description':
    'تحديد ما يُشارك على مستوى المؤسسة مقابل المشاريع الشخصية.',
  'help.topics.inst-structure.title': 'الهيكل والنطاق',
  'help.topics.inst-trash.description':
    'استعادة التدريبات أو البودكاست المحذوفة عند الحاجة.',
  'help.topics.inst-trash.title': 'سلة المحذوفات والاستعادة',
  'help.topics.marque-accessibilite.description':
    'التباينات، البدائل النصية والتنقل بلوحة المفاتيح في المحتويات.',
  'help.topics.marque-accessibilite.title': 'إتاحة الوصول وسهولة القراءة',
  'help.topics.marque-charte.description':
    'كيف تنعكس العلامة في المشغّل ومساحات المتعلّم.',
  'help.topics.marque-charte.title': 'الشارة والألوان المؤسسية',
  'help.topics.marque-landing.description':
    'عرض عرضكم التدريبي للزائر عند تفعيل الوحدة.',
  'help.topics.marque-landing.title': 'الصفحات العامة والكتالوج',
  'help.topics.medias-bibliotheque.description':
    'استيراد وتنظيم وإعادة استخدام الفيديوهات، الأصوات، الصور والمستندات في الكتل.',
  'help.topics.medias-bibliotheque.title': 'مكتبة الوسائط',
  'help.topics.medias-documents.description':
    'إرفاق موارد قابلة للتنزيل وربط التوثيق بالمسار.',
  'help.topics.medias-documents.title': 'المستندات وPDF',
  'help.topics.medias-studio-audio.description':
    'التسجيل، المزج أو استخدام التوليف الصوتي لإثراء المحتوى.',
  'help.topics.medias-studio-audio.title': 'استوديو الصوت والأصوات',
  'help.topics.medias-video.description':
    'ممارسات جيدة للتنسيق، الحجم وإتاحة الوصول للمشغّلات المدمجة.',
  'help.topics.medias-video.title': 'الفيديوهات والتكاملات',
  'help.topics.podcasts-creation.description':
    'هيكلة الحلقات، البيانات الوصفية والأغلفة لعرضكم الصوتي.',
  'help.topics.podcasts-creation.title': 'إنشاء بودكاست',
  'help.topics.podcasts-diffusion.description':
    'إعدادات الاستماع، المشاركة ومتابعة الاستخدام لدى المؤسسة.',
  'help.topics.podcasts-diffusion.title': 'البث والمتعلّمون',
  'help.topics.pub-catalogue.description':
    'ربط تدريب بالكتالوج المؤسسي أو بعرض عند تفعيل ذلك.',
  'help.topics.pub-catalogue.title': 'الكتالوج والظهور',
  'help.topics.pub-liens.description':
    'إنشاء أو نسخ الروابط للمتعلّمين، المُقدّمين أو المعاينة.',
  'help.topics.pub-liens.title': 'روابط الوصول والمشاركة',
  'help.topics.pub-statuts.description':
    'دورة حياة التدريب: حفظ، اختبار، نشر وإصدارات التغييرات.',
  'help.topics.pub-statuts.title': 'المسودة، النشر والتحديثات',
  'help.topics.qualite-qualiopi.description':
    'استخدام المساحات المخصّصة لتجهيز المعايير وملف الجودة.',
  'help.topics.qualite-qualiopi.title': 'ما قبل التدقيق ومؤشرات Qualiopi',
  'help.topics.qualite-tracabilite.description':
    'ربط الأهداف والمحتويات والتقييمات لتوثيق مسار معتمد.',
  'help.topics.qualite-tracabilite.title': 'تتبع تربوي',
  'help.topics.support-contact.description':
    'قناة الدعم، فتح تذكرة ومعلومات لتشخيص سريع.',
  'help.topics.support-contact.title': 'التواصل مع دعم Lyrra',
  'help.topics.support-faq.description':
    'المشغّل لا يحمّل، وسيط مفقود، خطأ نشر: أول إجراءات.',
  'help.topics.support-faq.title': 'مشاكل شائعة',
  'help.topics.support-navigateur.description':
    'إصدارات مُوصى بها، ملفات تعريف الارتباط والإضافات المزعجة.',
  'help.topics.support-navigateur.title': 'المتصفح والتوافق',
  'help.topics.v2-campagnes.description':
    'تخطيط نشر المسارات لجمهور مستهدف على مدى زمني.',
  'help.topics.v2-campagnes.title': 'الحملات وخطط التدريب',
  'help.topics.v2-competences.description':
    'ربط الكتل أو المسارات بالكفاءات المتوقعة للتقارير المهنية.',
  'help.topics.v2-competences.title': 'مراجع الكفاءات',
  'help.topics.v2-integrations.description':
    'تبادلات مع نظام الموارد البشرية، LMS خارجي أو أدوات BI عند وجود موصّلات.',
  'help.topics.v2-integrations.title': 'التكاملات وواجهة البرمجة',
};
